import { h } from "preact";
import { Page } from "../common/Page";

export const Projects = () => {
  return <Page> Under Construction </Page>;
};
